/**
 * Root Layout
 *
 * Main layout wrapper for public pages.
 */

import { Suspense } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { Header } from './header';
import { Loader2 } from 'lucide-react';

export function RootLayout() {
  const { pathname } = useLocation();
  const isModelScreen =
    pathname.startsWith('/models/') ||
    pathname.startsWith('/share/') ||
    pathname.startsWith('/gallery/');

  return (
    <div className="relative flex h-dvh flex-col">
      <Header />
      <main
        id="public-scroll-container"
        className={`min-h-0 flex-1 overflow-y-auto ${isModelScreen ? 'pt-16' : ''}`}
      >
        <Suspense
          fallback={
            <div className="flex h-[calc(100vh-4rem)] items-center justify-center">
              <Loader2 className="h-8 w-8 animate-spin text-muted-foreground" />
            </div>
          }
        >
          <Outlet />
        </Suspense>
      </main>
    </div>
  );
}

export default RootLayout;
